import { Expose, Type } from 'class-transformer';

import { FileModel } from './file.model';
import { ImageModel } from './image.model';
import { ProductListItemModelCPB } from './product.model';
import { LayoutProductType } from './layout-option.model';

export interface IUpdatePackage {
  optionId: number;
  name: string;
  description?: string;
  images: ImageModel[] | FileModel[];
  attributes: { id: number, isDefault: boolean}[]; 
  productTypesToUpdate: LayoutProductType[]
}

export class PackageLayoutProductType {
  @Expose({ name: 'id' })
  id!: number;

  @Expose({ name: 'layout_product_type_id' })
  layoutProductTypeId!: number;

  @Expose({ name: 'visible' })
  visible!: boolean;
  
}

export class PackageModel {
  @Expose({ name: 'id' })
  id!: number;
  @Expose({ name: 'description' })
  description!: string;
  @Expose({ name: 'name' })
  name!: string;
  @Expose({ name: 'images' }) @Type(() => ImageModel) images!: ImageModel[];
  @Expose({ name: 'products' }) @Type(() => ProductListItemModelCPB) products!: ProductListItemModelCPB[];


  @Expose({ name: 'package_layout_product_types' }) 
  @Type(() => PackageLayoutProductType)
  packageLayoutProductTypes!: PackageLayoutProductType[];
  
}

export class PackageModelShort {
  @Expose({ name: 'id' }) id!: number;
  @Expose({ name: 'name' }) name!: string;
  @Expose({ name: 'price' }) price!: number;
  selected = false;
}

export class CategoryProductModel {
  @Expose({ name: 'id' })
  id!: number;
  @Expose({ name: 'name' })
  name!: string;
  @Expose({ name: 'selected' })
  selected!: boolean;
  @Expose({ name: 'products' }) @Type(() => ProductListItemModelCPB) products!: ProductListItemModelCPB[];
  selectedProducts: ProductListItemModelCPB[] = [];
}

export class ClientPackageModel {
  @Expose({ name: 'id' })
  id!: number;
  @Expose({ name: 'description' })
  description!: string;
  @Expose({ name: 'total_price' })
  totalPrice!: string;
  @Expose({ name: 'currency' })
  currency!: string;
  @Expose({ name: 'name' })
  name!: string;
  @Expose({ name: 'selected' })
  selected!: boolean;
  @Expose({ name: 'images' }) @Type(() => ImageModel) images!: ImageModel[];
  @Expose({ name: 'categories' }) @Type(() => CategoryProductModel) categories!: CategoryProductModel[];

}

export class ClientPackageDataModel {
  @Expose({ name: 'layout_option_packages' }) @Type(() => ClientPackageModel) packages!: ClientPackageModel[];
  @Expose({ name: 'show_category_packages' }) showCategoryPackages!: boolean;
  @Expose({ name: 'option_design_line_products' }) optionDesignLineProducts!: boolean;
  navigateToSummary = false;
}

export class ClientIframePackageDataModel {
  @Expose({ name: 'packages' }) @Type(() => ClientPackageModel) packages!: ClientPackageModel[];
  @Expose({ name: 'show_category_packages' }) showCategoryPackages!: boolean;
  @Expose({ name: 'option_design_line_products' }) optionDesignLineProducts!: boolean;
  @Expose({ name: 'option_has_packages' }) optionHasPackages!: boolean;
  @Expose({ name: 'option_design_line' }) optionDesignLine!: boolean;
}

export class ClientIframeProductModel {
  @Expose({ name: 'category' }) category!: {
    id: number,
    name: string,
    description: string,
    totalPrice: number,
  };
  @Expose({ name: 'full_price' }) fullPrice!: number;

  @Expose({ name: 'id' }) id!: number;
  @Expose({ name: 'layout_product_type' }) layoutProductType!: any;
  @Expose({ name: 'products' }) products!: any[];
  @Expose({ name: 'layout_product_type_id' }) layoutProductTypeId!: number;
    
}
